import { render, staticRenderFns } from "./UpdateAssignee.vue?vue&type=template&id=2c28d75f&scoped=true&"
import script from "./UpdateAssignee.vue?vue&type=script&lang=js&"
export * from "./UpdateAssignee.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAssignee.vue?vue&type=style&index=0&id=2c28d75f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c28d75f",
  null
  
)

export default component.exports